// RegistrationModal.jsx
import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Row,
    Col,
    Label,
    Input,
    FormFeedback
} from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const RegistrationModal = ({
    modal,
    toggle,
    onSubmit,
    studyLevels = [],
    //students = [],
    academicYears = [],
    currentStudentId = null, // ID de l'étudiant actuel
    isEdit = false
}) => {
    // Schema Yup pour la validation
    const validationSchema = Yup.object().shape({
        academic_year_id: Yup.string().required("Année académique obligatoire"),
        study_level_id: Yup.string().required("Niveau d'étude obligatoire"),
        //faculty_id: Yup.string().required("Faculté obligatoire"),
        //branch_id: Yup.string().required("Filière obligatoire"),
        //student_id: Yup.string().required("Étudiant obligatoire"),
        //amount: Yup.number().typeError("Le montant doit être un nombre").required("Montant obligatoire")
    });

    // Valeurs initiales du formulaire
    const initialValues = {
        academic_year_id: "",
        //faculty_id: "",
        //branch_id: "",
        study_level_id: "",
        //student_id: currentStudentId || "",
        //amount: ""
    };

    return (
        <Modal isOpen={modal} toggle={toggle} backdrop="static">
            <ModalHeader toggle={toggle}>
                {isEdit ? "Modifier - Inscription" : "Nouvelle - Inscription"}
            </ModalHeader>
            <ModalBody>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values, actions) => {
                        onSubmit(values);
                        actions.setSubmitting(false);
                        toggle(); // fermer le modal après soumission
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting }) => (
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col className="col-12">
                                    {/* Année académique */}
                                    <div className="mb-3">
                                        <Label>Année académique</Label>
                                        <Input
                                            name="academic_year_id"
                                            type="select"
                                            value={values.academic_year_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            invalid={touched.academic_year_id && !!errors.academic_year_id}
                                        >
                                            <option value="">-- Sélectionner --</option>
                                            {(academicYears || []).map(c => (
                                                <option key={c.id} value={c.id}>{c.name}</option>
                                            ))}
                                        </Input>
                                        <FormFeedback>{errors.academic_year_id}</FormFeedback>
                                    </div>
                                    

                                    {/* Faculté 
                                    <div className="mb-3">
                                        <Label>Faculté</Label>
                                        <Input
                                            name="faculty_id"
                                            type="select"
                                            value={values.faculty_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            invalid={touched.faculty_id && !!errors.faculty_id}
                                        >
                                            <option value="">-- Sélectionner --</option>
                                            {(classRooms || []).map(c => (
                                                <option key={c.id} value={c.id}>{c.name}</option>
                                            ))}
                                        </Input>
                                        <FormFeedback>{errors.faculty_id}</FormFeedback>
                                    </div>
                                    */}

                                    {/* Filière 
                                    <div className="mb-3">
                                        <Label>Filière</Label>
                                        <Input
                                            name="branch_id"
                                            type="select"
                                            value={values.branch_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            invalid={touched.branch_id && !!errors.branch_id}
                                        >
                                            <option value="">-- Sélectionner --</option>
                                            {(classRooms || []).map(c => (
                                                <option key={c.id} value={c.id}>{c.name}</option>
                                            ))}
                                        </Input>
                                        <FormFeedback>{errors.branch_id}</FormFeedback>
                                    </div>
                                    */}



                                    {/* Niveau d'étude */}
                                    <div className="mb-3">
                                        <Label>Niveau d'étude</Label>
                                        <Input
                                            name="study_level_id"
                                            type="select"
                                            value={values.study_level_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            invalid={touched.study_level_id && !!errors.study_level_id}
                                        >
                                            <option value="">-- Sélectionner --</option>
                                            {(studyLevels || []).map(c => (
                                                <option key={c.id} value={c.id}>{c.name}</option>
                                            ))}
                                        </Input>
                                        <FormFeedback>{errors.study_level_id}</FormFeedback>
                                    </div>

                                    
                                    
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className="text-end">
                                        <Button color="primary" type="submit" disabled={isSubmitting}>
                                            {isEdit ? "Modifier" : "Valider"}
                                        </Button>
                                        <Button color="secondary" className="ms-2" onClick={toggle}>Annuler</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </ModalBody>
        </Modal>
    );
};

export default RegistrationModal;
